import { Bell, LogOut } from "lucide-react";
import { useAuth } from "@/lib/authContext";
import { useNavigate } from "react-router-dom";

export function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const initials =
    user?.name?.charAt(0).toUpperCase() ||
    user?.email?.charAt(0).toUpperCase() ||
    "A";

  return (
    <header className="toolbar">
      <div className="toolbar-spacer" />

      <button
        className="btn btn-secondary btn-icon cursor-pointer relative"
        aria-label="Notifications"
      >
        <Bell className="h-4 w-4" />
        <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-[var(--color-merry-pink)] shadow-[0_0_8px_rgba(255,51,119,0.7)]" />
      </button>

      <div className="mx-2 h-6 w-px bg-[var(--color-separator)]" />

      <div className="flex items-center gap-3 pr-1">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-pink-500 to-rose-600 text-[12px] font-semibold text-white shadow-[0_2px_6px_rgba(255,51,119,0.4)]">
          {initials}
        </div>
        <div className="hidden md:block leading-tight">
          <div className="text-[13px] font-medium text-white">
            {user?.name || "Admin"}
          </div>
          <div className="text-[11px] text-[var(--color-tertiary-label)]">
            {user?.role || "admin"}
          </div>
        </div>
      </div>

      <button
        onClick={handleLogout}
        className="btn btn-secondary btn-icon cursor-pointer"
        title="Logout"
        aria-label="Logout"
      >
        <LogOut className="h-4 w-4" />
      </button>
    </header>
  );
}